// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"5f4d8975","236":"a9064253","265":"93791527","387":"b8e0849d","392":"c893494f","430":"301cf082","666":"3e815376","748":"7504430b"}[chunkId] + ".chunk.js";
};